import request from '@/utils/request'

let Ma_classrm_mgmtApi = {

  /*课堂（课室）列表*/
  list(data) {
    return request._post('/shop/plus.ma_classrm_mgmt.Index/index', data);
},
/*添加课堂（课室）*/
add(data) {
    return request._post('/shop/plus.ma_classrm_mgmt.Index/add', data);
},
/*修改课堂（课室）*/
edit(data) {
    return request._post('/shop/plus.ma_classrm_mgmt.Index/edit', data);
},
/*删除课堂（课室）*/
del(data) {
    return request._post('/shop/plus.ma_classrm_mgmt.Index/del', data);
},
/*课堂（课室）详情*/
detail(data) {
  return request._post('/shop/plus.ma_classrm_mgmt.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_classrm_mgmt.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_classrm_mgmt.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_classrm_mgmt.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_classrm_mgmt.Index/export', data);
    },
}
export default Ma_classrm_mgmtApi;



// WEBPACK FOOTER //
// ./src/api/ma_classrm_mgmt.js